import React from 'react';
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';

/**
 * Conflict resolution dialog shown when a save returns HTTP 409 (optimistic
 * lock failure). The user can either reload the latest data or force their
 * own version (overwrite).
 */
export default function ConflictDialog({ open, conflict, onReload, onForce, onCancel }) {
    return (
        <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
            <AlertDialogContent data-testid="conflict-dialog" className="max-w-md">
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-amber-700">
                        Conflit de modification
                    </AlertDialogTitle>
                    <AlertDialogDescription className="space-y-2">
                        <span className="block">
                            <strong>{conflict?.modified_by_name || 'Un autre utilisateur'}</strong>
                            {' '}vient de modifier cette fiche.
                        </span>
                        <span className="block">
                            Vous pouvez recharger ses modifications ou forcer votre version
                            (les changements de l'autre utilisateur seront alors écrasés).
                        </span>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="gap-2 sm:gap-2">
                    <AlertDialogCancel data-testid="conflict-cancel" onClick={onCancel}>
                        Annuler
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={onReload}
                        data-testid="conflict-reload"
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Recharger
                    </AlertDialogAction>
                    <AlertDialogAction
                        onClick={onForce}
                        data-testid="conflict-force"
                        className="bg-red-600 hover:bg-red-700 text-white"
                    >
                        Forcer ma version
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
